
export default {
  name: 'LinkBtnWrap',
  props: {
    label: {
      type: String,
      default: '',
    },
    linkUrl: {
      type: String,
      default: '',
    },
  },
  methods: {
    jumpTo() {
      this.linkUrl && this.$open(this.linkUrl)
    },
  },
}
